var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-backgdround" }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-fade" }, [
      _c(
        "div",
        { staticClass: "modal" },
        [
          _c(
            "button",
            {
              staticClass: "modal-close",
              on: {
                click: function ($event) {
                  return _vm.modalClose()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "23",
                    height: "23",
                    viewBox: "0 0 23 23",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M2.00342 2L20.6685 20.6651",
                      stroke: "black",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.665 2L1.99993 20.6651",
                      stroke: "black",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _vm.stage === 1 && !_vm.isMobile
                ? _c("p", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n          Drop Files Here to Get Started\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.stage === 2
                ? _c("p", { staticClass: "modal-title" }, [
                    _vm._v("\n          Add Images\n        "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.stage === 1
                ? _c("ImageAdd", { on: { addFiles: _vm.addFiles } })
                : _vm.stage === 2
                ? [
                    _c("p", { staticClass: "modal-hint" }, [
                      _vm._v("Tap on title to rename."),
                    ]),
                    _vm._v(" "),
                    _c("AddedImages", {
                      attrs: { imagesList: _vm.filesData.images },
                      on: {
                        addFiles: _vm.addFiles,
                        imageRemove: _vm.imageRemove,
                        saveFiles: _vm.saveFiles,
                      },
                    }),
                  ]
                : _vm.stage === 3
                ? [
                    _c("p", { staticClass: "modal-title" }, [
                      _vm._v("Select Album"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "TabsWrapper",
                      [
                        _c("TabItem", { attrs: { title: "Public" } }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c("AddAlbumButton", {
                                    attrs: { id: "icon-3", modalItem: "" },
                                    on: { click: _vm.addPublicAlbum },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.publicPlaceholder.exist
                                ? _c(
                                    "div",
                                    { staticClass: "col" },
                                    [
                                      _c("AlbumItem", {
                                        attrs: {
                                          album: _vm.publicPlaceholder,
                                          modalItem: "",
                                          isPlaceholder: "",
                                        },
                                        on: {
                                          change: _vm.createPublicAlbum,
                                          deleteAlbumPlaceholder:
                                            _vm.deletePublicPlaceholder,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.publicAlbums, function (album) {
                                return [
                                  album.can_insert_image
                                    ? _c(
                                        "div",
                                        { key: album.id, staticClass: "col" },
                                        [
                                          _c("AlbumItem", {
                                            attrs: {
                                              album: album,
                                              modalItem: "",
                                            },
                                            on: { click: _vm.chooseAlbum },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("TabItem", { attrs: { title: "Private" } }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c("AddAlbumButton", {
                                    attrs: { modalItem: "" },
                                    on: { click: _vm.addPrivateAlbum },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.privatePlaceholder.exist
                                ? _c(
                                    "div",
                                    { staticClass: "col" },
                                    [
                                      _c("AlbumItem", {
                                        attrs: {
                                          album: _vm.privatePlaceholder,
                                          modalItem: "",
                                          isPlaceholder: "",
                                        },
                                        on: {
                                          change: _vm.createPrivateAlbum,
                                          deleteAlbumPlaceholder:
                                            _vm.deletePrivatePlaceholder,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.privateAlbums, function (album) {
                                return [
                                  album.can_insert_image
                                    ? _c(
                                        "div",
                                        { key: album.id, staticClass: "col" },
                                        [
                                          _c("AlbumItem", {
                                            attrs: {
                                              album: album,
                                              modalItem: "",
                                            },
                                            on: { click: _vm.chooseAlbum },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("TabItem", { attrs: { title: "NFTs" } }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c("AddAlbumButton", {
                                    attrs: {
                                      id: "icon-5",
                                      high: "",
                                      modalItem: "",
                                    },
                                    on: { click: _vm.createCollection },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.nftCollections, function (collection) {
                                return _c(
                                  "div",
                                  { key: collection.id, staticClass: "col" },
                                  [
                                    _c("NftItem", {
                                      attrs: { collection: collection },
                                      on: {
                                        click: function ($event) {
                                          return _vm.chooseCollection(
                                            collection.id
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                : [
                    !_vm.guidelines
                      ? [
                          _c("p", { staticClass: "modal-title" }, [
                            _vm._v("Permissions & Ownership"),
                          ]),
                          _vm._v(" "),
                          _c("Permissions", {
                            on: {
                              confirm: _vm.permissionsAccept,
                              openGuidelines: _vm.openGuidelines,
                            },
                          }),
                        ]
                      : [
                          _c("p", { staticClass: "modal-title" }, [
                            _vm._v("Guidelines"),
                          ]),
                          _vm._v(" "),
                          _c("Guidelines", {
                            on: { backToPermissions: _vm.backToPermissions },
                          }),
                        ],
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm.loading ? _c("PreloaderComponent") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { ref: "videoEl", staticClass: "hidden-video" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }